<template>
    <div
        class="mb-5"
    >

        <div style="position:relative;"
            class="mt-8"
        >

            <div
                style="position:relative;"
                @click="startScan"
            >
                <svg-icon 
                    type="mdi" 
                    :path="scan_svg"
                    width="120px"
                    height="120px"
                    :style="{
                        'color': setting.theme_color
                    }"
                >

                </svg-icon>
            </div>

            <div
                @click="startScan"
                style="position: absolute;left: 0px;top: 10px;right: 0px;bottom: 0px;"
            >
                <svg-icon 
                    class="my-icon"
                    type="mdi" 
                    :path="qrcode_svg"
                    width="100px"
                    height="100px"

                >

                </svg-icon>
            </div>

        </div>

        <v-dialog
            v-if="dialog"
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            eager
        >
            <v-card color="#000000">


                <div
                    style="position:relative;"
                >
                    <video 
                        ref="video"
                        id="qr-video" 
                        disablepictureinpicture="" 
                        playsinline="" 
                        style="transform: scaleX(-1);width:100%;">
                    </video>


                    <svg-icon 
                        style="position:absolute; transform: translate(-50%, -50%); left:40%; top:50%;"
                        class="my-icon"
                        type="mdi" 
                        :path="qrcode_svg"
                        width="50px"
                        height="50px"
                        :style="{
                            'color': qrcode_left ? 'rgba(0,255,0,0.8)' : 'rgba(255,255,255,0.8)'
                        }"
                    >

                    </svg-icon>

                    <svg-icon 
                        style="position:absolute; transform: translate(-50%, -50%); left:60%; top:50%;"
                        class="my-icon"
                        type="mdi" 
                        :path="qrcode_svg"
                        width="50px"
                        height="50px"
                        :style="{
                            'color': qrcode_right ? 'rgba(0,255,0,0.8)' : 'rgba(255,255,255,0.8)'
                        }"
                    >

                    </svg-icon>
                </div>


                <div class="d-flex align-center justify-center flex-column">
                    <v-card-title style="color:#FFFFFF;">將鏡頭對準發票QR Code</v-card-title>
                    <v-card-subtitle style="color:#FFFFFF;">此功能僅限 電子發票</v-card-subtitle>
                    <v-btn 
                        outlined @click="stopScan"
                        color="#FFFFFF"
                    >
                        關閉
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div> 
</template>

<script>
import QrScanner from 'qr-scanner';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiQrcode,mdiScanHelper } from '@mdi/js';
    export default {
        name: 'InvoiceScan',
        props: {
            setting: Object
        },
        components: {
            SvgIcon,
        },
        data: function(){
            return {
                qrcode_svg: mdiQrcode,
                scan_svg: mdiScanHelper,
                dialog: false,
                scanner: null,
                qrcode_left: '',
                qrcode_right: '',
                lock: false,
            }
        },
        mounted(){
        },
        methods: {
            startScan(){
                this.dialog = true
                this.$nextTick(() => {
                    const video = document.getElementById('qr-video');
                    console.log('1',this.$refs.video)
                    console.log('video',video)
                    const scanner = new QrScanner(
                        video,
                        result => this.setResult(result),
                        {
                            onDecodeError: () => {},
                            highlightScanRegion: true,
                            highlightCodeOutline: true,
                        }
                    );

                    scanner.start().then(() => {
                        console.log('start!')
                        let hightlight_border = document.querySelector('.scan-region-highlight')
                        let hightlights = Array.from(hightlight_border.querySelectorAll('svg'))
                        hightlights.forEach((hightlight) => {
                            hightlight.style.stroke = this.setting.theme_color
                        })
                    })
                    this.scanner = scanner
                });


            },
            setResult(result){
                console.log('result',result)
                if (this.lock) {
                    return
                }
                let content = result.data
                if (content.startsWith('**')) {
                    this.qrcode_right = content
                }
                else {
                    this.qrcode_left = content
                }
                if (this.qrcode_right &&  this.qrcode_left) {
                    this.lock = true
                    console.log('right:', this.qrcode_right)
                    console.log('left:', this.qrcode_left)
                    let data = {
                        left: this.qrcode_left,
                        right: this.qrcode_right
                    }
                    this.$emit('submit', data) 
                    // 送過去parent 檢查
                    // 開始loading 

                
                }
            },
            stopScan(){
                console.log('scanner',this.scanner)
                this.dialog = false
                this.scanner.stop()
                this.lock = false
                this.qrcode_left = ''
                this.qrcode_right = ''
            },
            // 檢查回來
            submitCallback(){
                this.stopScan()
            }

        }
    }
</script>
<style>

</style>